import { render, staticRenderFns } from "./_CreateProduct.vue?vue&type=template&id=54e61688&scoped=true&"
import script from "./_CreateProduct.vue?vue&type=script&lang=js&"
export * from "./_CreateProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e61688",
  null
  
)

export default component.exports